import SEO from '@seo/index';
import OfflineCentreLayout from '@layout/CitySpecificOfflineCentreLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { getOfflineCentreDetails } from '@api/fetchers/citySpecificOfflineCentre';
import OfflineCentres from '@cont/CitySpecificOfflineCentres/OfflineCentres';
import SomethingWentWrong from '@cont/CitySpecificOfflineCentres/SomethingWentWrong';
import fetchPageMetaInfo from '@api/fetchers/pageMetaInfo';
import Head from 'next/head';
import { SWRConfig } from 'swr';
import { useRouter } from 'next/router';
import { getKey } from '@api/hooks/citySpecificOfflineCentres/useCentreInfo';

const META_SEO_ID = 'Centre Pages';

const OfflineCentrePage = ({ centreData, pageMetaInfo }) => {
  const metaTitle = pageMetaInfo?.title || 'Unacademy Offline Centres';
  const metaDescription =
    pageMetaInfo?.description || 'Unacademy Offline Centres';
  const { centreDeepLinkUrl } = centreData || {};
  const {
    query: { centreUID, goalUID, source }
  } = useRouter();
  const { key } = getKey(centreUID, goalUID);
  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          url: centreDeepLinkUrl
        }}
        url={centreDeepLinkUrl}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      {!centreData ? (
        <SomethingWentWrong />
      ) : (
        <SWRConfig
          value={{
            revalidateOnMount: true,
            fallback: {
              [key]: centreData
            },
            dedupingInterval: 60 * 100
          }}
        >
          <OfflineCentres data={centreData} source={source} />
        </SWRConfig>
      )}
    </>
  );
};

OfflineCentrePage.pageInfo = {
  layoutOptions: {
    disableDarkMode: true,
    hideHeader: true,
    hideGoalSelector: true
  },
  isMWebSupported: true
};

// CDN cache with a TTL of 4hrs is enabled for this page
export const getStaticProps = async ({ params }) => {
  const { goalUID, centreUID } = params;
  if (goalUID === 'undefined')
    return {
      redirect: { destination: '/404' }
    };
  try {
    const promises = [];
    promises.push(getOfflineCentreDetails(goalUID, centreUID));
    promises.push(fetchPageMetaInfo(META_SEO_ID, `${goalUID}-${centreUID}`));
    const [offlineCentreDetails, pageMetaInfo] = await Promise.all(promises);

    return {
      props: {
        centreData: offlineCentreDetails,
        pageMetaInfo
      },
      revalidate: 60
    };
  } catch (error) {
    return {
      props: {}
    };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

OfflineCentrePage.Layout = OfflineCentreLayout;

OfflineCentrePage.Layout.displayName = 'Offline centre page';

OfflineCentrePage.propTypes = {};

export default OfflineCentrePage;
OfflineCentrePage.Wrapper = PageReduxProvider;
